import React, {Fragment,Component,useState,useEffect} from 'react';
import axios from 'axios';
import {connect} from 'react-redux';
import Iframe from "react-iframe"
import { Redirect,Link } from 'react-router-dom';
import { Table,Placeholder } from 'semantic-ui-react';
import {
  Menu,
  Segment,
  Container,
  Divider,
  Message,
  Icon,
  Header,
  Dimmer,
  Responsive,
  Modal,
  Button,
  Image,
  Loader,
  Tab,
  Label
} from 'semantic-ui-react';
import {Base64} from 'js-base64';
import Clipboard from 'react-clipboard.js';

function Guide(props){

  const [synchronized, setSynchronized] = useState(true);
  const [current, setCurrent] = useState(0);

  useEffect(() => {

    axios.request("/common/time",{
      method:"GET",
      headers:{
        'Content-Type': 'application/json'
      }
    }).then(async (res)=>{

      setCurrent(new Date(res.data.time).toLocaleString());

      if(Math.abs(res.data.time - new Date().getTime()) < 2 * 60 * 1000 ){
        setSynchronized(true);
      }else{
        setSynchronized(false);
      }

    })

    return ()=>{ }

  }, []);

  const {t}       = props;
  const mobile    = /Android|iPhone|iPod/.test(navigator.userAgent);
  const title     = props.data.title;
  const port      = props.data.port;
  const password  = props.data.password;
  const code      = props.data.code;
  const hashed    = props.data.hashed;
  const user_id   = props.data.user_id;
  const user_vip  = props.data.user_vip;

  const winDownload         = "https://glados.rocks/tools/Clash.for.Windows.Setup.exe";
  const clashDownload       = "https://glados.rocks/tools/cfa-2.5.9-premium-universal-release.apk";
  const macDownload         = "https://glados.rocks/tools/ClashX.dmg";

  //subscribe_endpoint = "update.glados-config.net";
  //subscribe_endpoint = "update.glados-config.org";
  var subscribe_endpoint = "update.glados-config.com";
  var alt_subscribe_endpoint = "www.glados-config.com";

  const sub    = 'sub://' + Base64.encode(`https://${subscribe_endpoint}/subscribe/${user_id}/${code}/${port}/servers`) + "#Github.com/GLaDOS-network";
  const suburl           = `https://${subscribe_endpoint}/clash/${user_id}/${code}/${port}/glados.yaml`
  const altsub           = `https://${alt_subscribe_endpoint}/clash/${user_id}/${code}/${port}/glados.yaml`

  const ipv6             = `https://${subscribe_endpoint}/clash/${user_id}/${code}/${port}/glados-ipv6.yaml`
  const padavan_suburl   = `https://${subscribe_endpoint}/clash/${user_id}/${code}/${port}/glados-padavan.yaml`
  const android_suburl   = `https://${subscribe_endpoint}/clash/${user_id}/${code}/${port}/glados-android.yaml`
  const koolshare_suburl = `https://${subscribe_endpoint}/clash/${user_id}/${code}/${port}/koolshare.yaml`
  const openclash_suburl = `https://${subscribe_endpoint}/clash/${user_id}/${code}/${port}/glados-openclash.yaml`
  const clash_restrict_suburl = `https://${subscribe_endpoint}/clash/${user_id}/${code}/${port}/glados.restrict.yaml`
  const [url,setURL] = useState(false);

  if(url){
    return <Redirect to={url}/>
  }

  var panes = [{
      desktop:true,
      mobile:true,
      menuItem:<Menu.Item key='pro2'>
        <svg id="windows" style={{"color":"#333","width":"26px","marginRight":"8px", "verticalAlign": "middle"}}   viewBox="0 0 36 24">
          <path d="M6.5 3.27934L15.9055 1.99281V11.051H6.5V3.27934ZM17.0384 1.81427L29.5 0V10.9749H17.0384V1.81427ZM6.5 12.0094H15.9055V21.0938L6.5 19.7811V12.0094ZM17.0384 12.1301H29.5V23L17.0384 21.2409" fill="currentColor"></path>
        </svg>
        Clash For Windows
      </Menu.Item>,
      render: () => {

        return (<Tab.Pane style={{padding:"10px",margin:"0px"}}>
          <p style={{color:"black"}}>1. 点击下载 <a  href={winDownload}>Clash For Windows 客户端</a>, 然后安装</p>
          <p>2. 右键管理员权限运行 Clash 客户端后，<button><a href={`clash://install-config?url=${suburl}&name=GLaDOS`}>鼠标左键点击这里</a></button>  添加订阅地址, 并点击下载按钮</p>
          <p style={{color:"red"}}>3. 选择General面板, 打勾 System Proxy(系统代理)</p>
          <p>4. 打开浏览器访问 Google.com 测试</p>


          <p>如果无法自动导入，请进入 Clash 的 Profile 面板下载配置文件(
            <span>{suburl}</span>
            <Clipboard
              style={{"borderRadius": "5px", "padding": "4px"}}
              onSuccess={()=>{ setClipboard(true) }}
              data-clipboard-text={suburl}>
              { clipboard ? "copied" : "copy to clipboard" }
            </Clipboard>
          ), 然后选择生效</p>

          <p>如果遇到订阅配置文件失败:</p>
          <ul>
            <li>订阅前关闭系统代理, 再试</li>
            <li>修改系统 DNS 为 119.29.29.29, 再试</li>
          </ul>

          <p>Clash For Windows 注意事项:</p>
          <ul>
            <li>请设置为系统代理</li>
            <li>Clash 因为升级/设置问题出错，请点击"General -> Home Directory", 然后删除目录里的文件和子目录, 再重新订阅。</li>
            <li>请打开订阅文件自动更新功能</li>
            <li>默认使用Rule模式，不要改为全局或直接连接</li>
          </ul>

          <p>如果遇到问题, 请进入<Link to="/console/client">自动诊断</Link></p>

        </Tab.Pane>)
      }
    }
  ]

  const [clipboard,setClipboard] = useState(false);

  return (
  <Fragment>

    <Header as='h2' color="blue">
      {t("settings.windows.title")}
      <Header.Subheader>
      {t("settings.windows.notes")}
      </Header.Subheader>
    </Header>
    <p>{t("settings.clash.what")}</p>
    <p>{t("settings.clash.steps")}</p>
    <p>1.{t("settings.clash.step1")}</p>
    <p>2.{t("settings.clash.step2")}</p>
    <p>3.{t("settings.clash.step3")}</p>

    <Table>
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell colSpan='3'>
            Windows
          </Table.HeaderCell>
        </Table.Row>
      </Table.Header>

      <Table.Body>
        <Segment>
          <Tab  menu={{ color:"blue", secondary: true}} panes={panes} />
        </Segment>
      </Table.Body>
    </Table>

    <Link to="/console/rules">
          <Message icon>
            <Icon color='blue' name="tasks alternate circle" />
            <Message.Content>
              <Message.Header>Clash Rules Editor</Message.Header>
              Add costomized rules to your clash config file.
            </Message.Content>
          </Message>
    </Link>
  </Fragment>
  )
}
export {Guide};
